<span class="c-spinner text-6xl " data-module="c-spinner">
  <span class="sr-only" role="alert" aria-live="assertive"> </span>
</span>